import { useEffect, useState } from "react";
import { useApenasConsulta } from "./useApenasConsulta";
import { useTravaPlanilhaN1 } from "./useTravaPlanilhaN1";
import { TipoMaterialN1 } from "../types/materiaisN1.types";

// Mesma chave usada pela listagem (ProdutosN1/index.tsx) ao alternar o toggle.
const STORAGE_KEY_MODO_EDICAO = "@MOF:produtosN1:modoEdicao";

/**
 * FASE 05 — 6ª validação/PO 2026-08-11: os recursos de edição dos cadastros N1 só ficam
 * disponíveis com a chave MODO EDIÇÃO **ligada**. Com ela desligada a tela abre em
 * somente-leitura (o usuário está vendo a versão publicada no mercado, que não se edita).
 *
 * Combina as regras de bloqueio:
 *  - empresa com "Liberação dos cadastros apenas para consulta" (B4, 2ª validação);
 *  - Modo Edição desligado (esta regra);
 *  - plano 14/10/2026 (Frente 4): planilha do tipo em andamento na empresa — a edição manual
 *    espera a planilha ser concluída ou excluída (o aviso é o AvisoPlanilhaPendenteN1).
 */
export const useSomenteLeituraN1 = (tipoMaterial?: TipoMaterialN1): boolean => {
  const apenasConsulta = useApenasConsulta();
  const { trava } = useTravaPlanilhaN1(tipoMaterial);
  const [modoEdicaoAtivo, setModoEdicaoAtivo] = useState<boolean>(() =>
    sessionStorage.getItem(STORAGE_KEY_MODO_EDICAO) === "true"
  );

  // Mantém sincronizado caso a chave seja alterada em outra aba/janela.
  useEffect(() => {
    const aoMudar = () =>
      setModoEdicaoAtivo(sessionStorage.getItem(STORAGE_KEY_MODO_EDICAO) === "true");
    window.addEventListener("storage", aoMudar);
    return () => window.removeEventListener("storage", aoMudar);
  }, []);

  return apenasConsulta || !modoEdicaoAtivo || !!trava?.planilhaPendente;
};
